module.exports = __webpack_public_path__ + "img/calendar.efbb03f0.svg";